module.exports = __webpack_public_path__ + "static/mou-3278877a819519517093962634e7542f.jpeg";